import { render, staticRenderFns } from "./AppChatMessages.vue?vue&type=template&id=cdc78400"
import script from "./AppChatMessages.vue?vue&type=script&lang=js"
export * from "./AppChatMessages.vue?vue&type=script&lang=js"
import style0 from "./AppChatMessages.vue?vue&type=style&index=0&id=cdc78400&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports